// currently the filter is a bit backwards because the default state is ON
// things only change if the filter gets turned OFF

export default function filterIngredients(ingredients, filterId, filter) {  
  let filteredSections;
  // starting with entire sections of ingredients
  // if filter is true
  if (filter) {
    // leave ingredients unchanged
    filteredSections = ingredients
  } else {
    // otherwise, remove section with id that matches filterId
    filteredSections = ingredients.filter(section => section.id !== filterId);
  }

  // then within each section
  const result = filteredSections.map(section => {
    let filteredItems;
    // if filter is false
    if (filter) {
      // remove items that match the filterId
      filteredItems = section.items.filter(item => item.filterId !== filterId);
    } else {
      // otherwise, leave items unchanged
      filteredItems = section.items;
    }
    
    // Return a new section object with the filtered items
    return { ...section, items: filteredItems };
  });

  return result;
}